import { render, staticRenderFns } from "./desktop-root.vue?vue&type=template&id=de11d8b6"
import script from "./desktop-root.vue?vue&type=script&lang=js"
export * from "./desktop-root.vue?vue&type=script&lang=js"
import style0 from "./desktop-root.vue?vue&type=style&index=0&id=de11d8b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports